import script from "./build-sprint-projects-review.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-sprint-projects-review.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__